// Brand Icons
import { fab } from "@fortawesome/free-brands-svg-icons"

// Free Solid Icons
import {
	faScrewdriverWrench,
	faTruck as faTruckSolid,
	faDollar as faDollarSolid,
	faMessage as faMessageSolid,
} from "@fortawesome/free-solid-svg-icons"

// Pro Light Icons
import { faTimes as faTimesLight } from "@fortawesome/pro-light-svg-icons"

// Pro Regular Icons (default)
import {
	faAngleDown,
	faAngleUp,
	faArrowDown,
	faArrowRight,
	faArrowRightFromBracket,
	faBan,
	faBars,
	faBell,
	faBellOn,
	faBolt,
	faBox,
	faBullhorn,
	faCalendar,
	faCarCrash,
	faCarWash,
	faChartBar,
	faCheck,
	faCheckCircle,
	faCheckSquare,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleUser,
	faCloud,
	faCloudRain,
	faCloudShowersHeavy,
	faCloudSnow,
	faCloudSun,
	faCloudSunRain,
	faClouds,
	faCloudsMoon,
	faCloudsSun,
	faCommentAltLines,
	faCreditCard,
	faDollar,
	faDollarSign,
	faDownload,
	faEnvelope,
	faFileInvoiceDollar,
	faFilePdf,
	faFilter,
	faGlobe,
	faHome,
	faHurricane,
	faInfoCircle,
	faLink,
	faLock,
	faLongArrowDown,
	faLongArrowLeft,
	faLongArrowRight,
	faLongArrowUp,
	faMinus,
	faMoneyBillWave,
	faMoon,
	faMoonCloud,
	faPaperPlane,
	faPencil,
	faPersonDigging,
	faPhone,
	faPlus,
	faPrescriptionBottle,
	faQuestionCircle,
	faSatelliteDish,
	faSearch,
	faShoppingCart,
	faSignIn,
	faSignOut,
	faSms,
	faSpinnerThird,
	faSquare,
	faSun,
	faSunCloud,
	faSync,
	faTable,
	faTag,
	faThunderstorm,
	faTimes,
	faTrash,
	faTriangleExclamation,
	faUniversity,
	faUsdCircle,
	faUser,
	faUserHardHat,
	faUserHeadset,
	faUserPlus,
	faUsersCog,
	faWifiSlash,
	faWind,
} from "@fortawesome/pro-regular-svg-icons"

// Pro Solid Icons
import {
	faCaretDown as faCaretDownSolid,
	faCaretRight as faCaretRightSolid,
	faCaretUp as faCaretUpSolid,
	faCheckCircle as faCheckCircleSolid,
	faCircleXmark,
	faExclamationTriangle as faExclamationTriangleSolid,
	faInfoCircle as faInfoCircleSolid,
	faLock as faLockSolid,
	faShoppingCart as faShoppingCartSolid,
	faUnlock,
	faUser as faUserSolid,
	faWrench as faWrenchSolid,
	faCartCirclePlus,
} from "@fortawesome/pro-solid-svg-icons"

// Icon Registry
export const faIcons = [
	// Brands
	fab,

	// Free Solid
	faScrewdriverWrench,
	faTruckSolid,
	faDollarSolid,

	// Pro Light
	faTimesLight,

	// Pro Regular
	faAngleDown,
	faAngleUp,
	faArrowDown,
	faArrowRight,
	faArrowRightFromBracket,
	faBan,
	faBars,
	faBell,
	faBellOn,
	faBolt,
	faBox,
	faBullhorn,
	faCalendar,
	faCartCirclePlus,
	faCarCrash,
	faCarWash,
	faChartBar,
	faCheck,
	faCheckCircle,
	faCheckSquare,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleUser,
	faCloud,
	faCloudRain,
	faCloudShowersHeavy,
	faCloudSnow,
	faCloudSun,
	faCloudSunRain,
	faClouds,
	faCloudsMoon,
	faCloudsSun,
	faCommentAltLines,
	faCreditCard,
	faDollar,
	faDollarSign,
	faDownload,
	faEnvelope,
	faFileInvoiceDollar,
	faFilePdf,
	faFilter,
	faGlobe,
	faHome,
	faHurricane,
	faInfoCircle,
	faLink,
	faLock,
	faLongArrowDown,
	faLongArrowLeft,
	faLongArrowRight,
	faLongArrowUp,
	faMessageSolid,
	faMinus,
	faMoneyBillWave,
	faMoon,
	faMoonCloud,
	faPaperPlane,
	faPencil,
	faPersonDigging,
	faPhone,
	faPlus,
	faPrescriptionBottle,
	faQuestionCircle,
	faSatelliteDish,
	faSearch,
	faShoppingCart,
	faSignIn,
	faSignOut,
	faSms,
	faSpinnerThird,
	faSquare,
	faSun,
	faSunCloud,
	faSync,
	faTable,
	faTag,
	faThunderstorm,
	faTimes,
	faTrash,
	faTriangleExclamation,
	faUniversity,
	faUsdCircle,
	faUser,
	faUserHardHat,
	faUserHeadset,
	faUserPlus,
	faUsersCog,
	faWifiSlash,
	faWind,

	// Pro Solid
	faCaretDownSolid,
	faCaretRightSolid,
	faCaretUpSolid,
	faCheckCircleSolid,
	faCircleXmark,
	faExclamationTriangleSolid,
	faInfoCircleSolid,
	faLockSolid,
	faShoppingCartSolid,
	faUnlock,
	faUserSolid,
	faWrenchSolid,
]
